import React, { useState, useCallback } from "react";

import CreateMeeting from "../../components/dashboard/CreateMeeting";

import { Menu } from "lucide-react";
import AssignmentList from "./Components/AssignmentList";
import StudentDashBoardSidebar from "./Components/Sidebar";
import DashboardSemester from "./Components/StudentDashboardSemester";
import Courseware from "./Components/CoursewareV2";
import SwayamKanbanBoard from "./Components/ToDoList";
import { useUtilityContext } from "../../context/UtilityContext";
import StudentStatsSection from "./Components/StudentStatsSection";
import StudentGradebook from "./Components/StudentGradebook";
import StudentProfilePage from "./Components/ProfileSection";
import AccountSettings from "../TeacherDashboard/Components/TeacherProfile/TeacherAccountSettings";
import InlineCourseView from "./Components/InlineCourseView";

const Dashboard = () => {
  const { activeSection, setActiveSection, setSelectedCourseId, setActiveCourseTab } = useUtilityContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [courseViewOptions, setCourseViewOptions] = useState({});

  const handleCourseClick = useCallback(
    (courseId, options = {}) => {
      setSelectedCourseId(courseId);
      setActiveCourseTab(options.initialTab || "Home");
      setCourseViewOptions(options);
      setActiveSection("CourseDetail");
    },
    [setSelectedCourseId, setActiveSection, setActiveCourseTab]
  );

  return (
    <div className="flex h-fit min-h-screen dark:bg-gray-900 dark:text-white relative">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(true)}
        className="fixed top-3 left-3 sm:top-4 sm:left-4 z-30 lg:hidden p-2 rounded-sm bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5 sm:h-6 sm:w-6 text-gray-700 dark:text-gray-300" />
      </button>

      {/* Sidebar */}
      <StudentDashBoardSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isMobileOpen={isMobileMenuOpen}
        setIsMobileOpen={setIsMobileMenuOpen}
      />

      {/* Main Content */}
      <div className="w-full lg:flex-1 lg:ml-0 max-h-screen overflow-y-auto overflow-x-hidden">
        {activeSection === "Dashboard" && (
          <DashboardSemester setActiveSection={setActiveSection} onCourseClick={handleCourseClick} />
        )}

        {activeSection === "MyStats" && <StudentStatsSection />}
        {activeSection === "Assignment" && <AssignmentList />}
        {activeSection === "Courseware" && <Courseware onCourseClick={handleCourseClick} />}
        {activeSection === "Gradebook" && <StudentGradebook />}
        {activeSection === "LiveClass" && <CreateMeeting />}
        {activeSection === "ToDo" && <SwayamKanbanBoard />}
        {activeSection === "Profile" && <StudentProfilePage />}
        {activeSection === "Settings" && <AccountSettings />}
        {activeSection === "CourseDetail" && (
          <InlineCourseView
            initialTab={courseViewOptions.initialTab}
            initialAssignmentId={courseViewOptions.assignmentId}
          />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
